import { 
  doc, 
  setDoc, 
  updateDoc, 
  collection, 
  addDoc,
  serverTimestamp,
  arrayUnion
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from './firebase';
import { SOPStep } from './store-sop-checklist';

export interface SOPLogData {
  technicianId: string;
  technicianEmail: string;
  sopName: string;
  startTime: Date;
  endTime?: Date;
  steps: Array<{
    name: string;
    status: string;
    timestamp: Date;
    evidence: string;
    message?: string;
  }>;
  videoUrl?: string;
  status: 'in-progress' | 'completed' | 'abandoned';
  completeLog: string;
}

class SOPLogger {
  private currentLogId: string | null = null;
  private currentLogRef: any = null;

  async startSOPLog(
    technicianId: string,
    technicianEmail: string,
    sopName: string
  ): Promise<string> {
    try {
      const logData: Partial<SOPLogData> = {
        technicianId,
        technicianEmail,
        sopName,
        startTime: new Date(),
        steps: [],
        status: 'in-progress',
        completeLog: ''
      };

      const docRef = await addDoc(collection(db, 'sopLogs'), logData);
      this.currentLogId = docRef.id;
      this.currentLogRef = docRef;
      
      console.log('SOP Log started with ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Error starting SOP log:', error);
      throw error;
    }
  }

  async updateStep(logId: string, step: SOPStep) {
    try {
      const stepData = {
        ...step,
        timestamp: new Date()
      };

      // Use arrayUnion to append the step to the steps array
      await updateDoc(doc(db, 'sopLogs', logId), {
        steps: arrayUnion(stepData)
      });
      
      console.log('Step logged:', step.name);
    } catch (error) {
      console.error('Error logging step:', error);
      throw error;
    }
  }

  async uploadVideo(logId: string, videoBlob: Blob): Promise<string> {
    const videoRef = ref(storage, `sop-videos/${logId}.webm`);
    await uploadBytes(videoRef, videoBlob);
    const downloadURL = await getDownloadURL(videoRef);
    
    await updateDoc(doc(db, 'sopLogs', logId), {
      videoUrl: downloadURL
    });

    return downloadURL;
  }

  async completeSOPLog(logId: string, completeLog: string) {
    await updateDoc(doc(db, 'sopLogs', logId), {
      endTime: new Date(),
      status: 'completed',
      completeLog
    });
    
    this.currentLogId = null;
    this.currentLogRef = null;
  }

  async abandonSOPLog(logId: string, completeLog: string) {
    await updateDoc(doc(db, 'sopLogs', logId), {
      endTime: new Date(),
      status: 'abandoned',
      completeLog
    });
    
    this.currentLogId = null;
    this.currentLogRef = null;
  }

  getCurrentLogId(): string | null {
    return this.currentLogId;
  }
}

export const sopLogger = new SOPLogger(); 